<template>
  <div class="documents-section invoice-section">
    <div v-if="!loading">
      <template v-if="showUploaderSection">
        <h3 class="title-slash headings">
          {{ $t('invoices.single.documents.pending') }}
        </h3>
        <div class="section">
          <b-row>
            <b-col
              v-for="items in uploadTasks"
              :key="items.id"
              :lg="12"
              class="mb-4"
            >
              <file-upload
                :task="items.task"
                @added="uploadInProgress++"
                @complete="uploadInProgress--"
                @success="success(items)"
                :uploadDoc="items.doc"
                :multiple="['po', 'sb-in'].includes(items.doc.key)"
              />

              <div
                v-if="isDiscrepantInvoice(items)"
                class="invoice-dissimilarity-container d-flex"
              >
                <b-icon-exclamation-circle-fill
                  class="icon-warning"
                  color="red"
                />
                <div>
                  <b>
                    <p class="dissimilarity-title">
                      {{
                        $t('invoices.add.helpers.discrepantInvoice.title', {
                          docName: items.doc.name
                        })
                      }}
                    </p>
                  </b>
                  <p class="dissimilarity-msg">
                    <b>
                      {{
                        $t(
                          'invoices.add.helpers.discrepantInvoice.commentLabel'
                        )
                      }}:
                    </b>
                    {{ isDiscrepantInvoice(items).comment }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </template>
      <template
        v-if="
          invoice &&
          invoice.documents_public &&
          invoice.documents_public.length > 0
        "
      >
        <h3 class="title-slash headings">
          {{ $t('invoices.single.documents.uploaded') }}
        </h3>
        <div class="section">
          <b-row>
            <b-col
              :lg="12"
              v-for="document in invoice.documents_public"
              :key="document.id"
            >
              <div
                class="d-flex justify-content-between align-items-center document-container mb-3 mb-md-4"
              >
                <div class="icon">
                  <div class="svg">
                    <b-icon-file-earmark-text-fill />
                  </div>
                </div>
                <div class="content text-left w-100">
                  <p class="upload-placeholder-title">
                    {{
                      $t(
                        `invoices.single.uploadDocs.${document.tags_value_key}`
                      )
                    }}
                    <small>({{ document.file_size_human }})</small>
                  </p>
                  <a
                    v-track-click
                    id="file-download-cta"
                    :href="getDownloadUrl(document)"
                    target="_blank"
                    class="upload-desc"
                  >
                    {{ $t('invoices.single.documents.date') }}
                    {{
                      (document.updated_at || 'N/A')
                        | formatDate('DD MMMM, YYYY')
                    }}
                  </a>
                </div>
                <div class="icon">
                  <div class="svg">
                    <a
                      v-track-click
                      id="file-download-cta"
                      :href="getDownloadUrl(document)"
                      target="_blank"
                    >
                      <b-icon-download />
                    </a>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </template>
    </div>
    <loader v-else :height="500" />
  </div>
</template>
<script>
import Loader from '@/components/common/Loader'
import FileUpload from '@/components/invoices/Add/Forms/FileUpload.vue'

export default {
  props: ['invoice', 'value', 'discrepantInvoices'],
  data() {
    return {
      loading: false,
      uploadInProgress: 0
    }
  },
  computed: {
    uploadTasks() {
      if (!this.invoice.task_flows) {
        return []
      }
      const upload_ = this.invoice.task_flows.filter((task) => {
        const regex = new RegExp(this.invoice.doc_set_2.join('|'), 'gi')
        const except =
          this.invoice &&
          this.invoice.doc_set_2 &&
          this.invoice.doc_set_2.length > 0 &&
          task.uid.match(regex)
        return task.uid.indexOf('upload_') > -1 && !except
      })
      const tasks = []
      upload_.forEach((task) => {
        task.upload_docs.forEach((doc) => {
          // const docIsDiscrepant = this.discrepantInvoices.find(d => doc.key.startsWith(d.document_type))
          // const docIsPending = ['pending', 'done'].includes(task.status)
          const docNotUploaded = !this.getUploadedDocs.find((tag) =>
            doc.key.startsWith(tag)
          )
          const isNotDuplicate = !tasks.find(({ doc: d }) => d.key === doc.key)

          if (isNotDuplicate && docNotUploaded) {
            tasks.push({ task: task, doc: doc })
          }
        })
      })
      return tasks.reverse()
    },
    getUploadedDocs() {
      return this.invoice.documents_public.map(
        (document) => document.tags_normal
      )
    },
    isDone() {
      if (!this.invoice.task_flows) {
        return true
      }
      return (
        this.invoice.task_flows.filter(
          (task) =>
            task.uid.indexOf('upload_') > -1 && task.status === 'pending'
        ).length === 0
      )
    },
    showUploaderSection() {
      const discrepantInvoicesExists =
        this.discrepantInvoices && this.discrepantInvoices.length
      const uploadTasksExists = this.uploadTasks && this.uploadTasks.length
      const advancesEmpty =
        this.invoice &&
        this.invoice.advances &&
        this.invoice.advances.length === 0
      return (
        (!this.invoice['basic_documents_uploaded?'] ||
          discrepantInvoicesExists ||
          uploadTasksExists) &&
        advancesEmpty
      )
    }
  },
  methods: {
    success(inv) {
      inv.task.status = 'done'
      if (this.isDone) {
        this.$emit('trigger-esign')
      }
      if (this.discrepantInvoices && this.discrepantInvoices.length) {
        this.$emit('update-discrepant-invoices', inv.doc.key)
      }
    },
    getDownloadUrl(document) {
      return `${process.env.VUE_APP_DRIP_WEB_HOST}/documents/${document.id}/auth/${document.auth_token}`
    },
    isDiscrepantInvoice(inv) {
      return (
        this.discrepantInvoices &&
        this.discrepantInvoices.find((i) =>
          inv.doc.key.startsWith(i.document_type)
        )
      )
    }
  },
  components: {
    Loader,
    FileUpload
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/_variables.scss';
.confirm-modal {
  .modal-dialog {
    width: 45rem;
    max-width: 100%;
    .modal-body {
      padding: 1.67rem;
    }
  }
}
.invoice-dissimilarity-container {
  background-color: $drip-red-10;
  border-radius: 0.25rem;
  padding: 0.9375rem 0.9375rem;
  margin: 0.375rem 0 0 0;

  .icon-warning {
    margin: 0.1875rem 0.5rem 0 0;
  }

  .dissimilarity-msg {
    color: $lighter-text;
    margin: 0;
  }
}
</style>
